
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31.379","height":"31.379"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Groupe_103","data-name":"Groupe 103"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Tracé_225","d":"M35.961 33.939l-8.089-8.089a12.848 12.848 0 10-10.041 4.811 12.687 12.687 0 008.019-2.824l8.089 8.124a1.4 1.4 0 001.011.418 1.456 1.456 0 001.011-.418 1.431 1.431 0 000-2.022zm-18.13-6.1a9.989 9.989 0 1110.006-10.008 9.97 9.97 0 01-10.006 10.006z","data-name":"Tracé 225","transform":"translate(-5 -5)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Tracé_226","d":"M35.407 29.689h-2.859V26.83a1.43 1.43 0 10-2.859 0v2.859H26.83a1.43 1.43 0 100 2.859h2.859v2.859a1.43 1.43 0 002.859 0v-2.859h2.859a1.414 1.414 0 001.43-1.43 1.436 1.436 0 00-1.43-1.429z","data-name":"Tracé 226","transform":"translate(-18.287 -18.287)"}})])])
          )
        }
      }
    